import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {AuthService} from '../services/auth/auth.service';
import {OAuthService} from 'angular-oauth2-oidc';

@Component({
  selector: 'app-auth-callback',
  templateUrl: './auth-callback.component.html',
  styleUrls: ['./auth-callback.component.css']
})
export class AuthCallbackComponent implements OnInit {
  content: any;

  constructor(
    private authService: AuthService,
    private router: Router,
    private readonly oauthService: OAuthService,
    private http: HttpClient) {
  }

  async ngOnInit() {
    console.log('yesssssssss', 'AuthCallbackComponent');
    const returnUrl = localStorage.getItem('returnUrl');
    console.log(returnUrl);
    if (returnUrl) {
      this.router.navigateByUrl(returnUrl);
    }
  }

}
